import Transitions from "components/@extended/Transitions";
import { CardContent, ClickAwayListener, Paper, Popper } from "@mui/material";
import MainCard from "components/MainCard";
import { Divider, Grid, Typography } from "@mui/material";
import CoPresentOutlinedIcon from "@mui/icons-material/CoPresentOutlined";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import ClassOutlinedIcon from "@mui/icons-material/ClassOutlined";
import Diversity3OutlinedIcon from "@mui/icons-material/Diversity3Outlined";
import CorporateFareOutlinedIcon from "@mui/icons-material/CorporateFareOutlined";
import PeopleOutlineOutlinedIcon from "@mui/icons-material/PeopleOutlineOutlined";
import ProjectSearch from "layout/MainLayout/Header/HeaderContent/Profile/GlobalSearch/ProjectSearch";
import DesignationSearch from "layout/MainLayout/Header/HeaderContent/Profile/GlobalSearch/DesignationSearch";
import DepartmentSearch from "layout/MainLayout/Header/HeaderContent/Profile/GlobalSearch/DepartmentSearch";
import RoleSearch from "layout/MainLayout/Header/HeaderContent/Profile/GlobalSearch/RoleSearch";
import EmployeeSearchCard from "layout/MainLayout/Header/HeaderContent/Profile/GlobalSearch/EmployeeSearchCard";
import CompanySearch from "layout/MainLayout/Header/HeaderContent/Profile/GlobalSearch/CompanySearch";
import { makeStyles } from "@mui/styles";

const icons = {
  Roles: <CoPresentOutlinedIcon />,
  Projects: <FactCheckOutlinedIcon />,
  Designations: <ClassOutlinedIcon />,
  Departments: <Diversity3OutlinedIcon />,
  Companies: <CorporateFareOutlinedIcon />,
  Employee: <PeopleOutlineOutlinedIcon />,
};

const useStyle = makeStyles((theme) => ({
  hrmsGlobalSearchResult: {
    boxShadow: theme.customShadows.z1,
    width: 450,
    minWidth: 240,
    marginRight: "10px",
    maxHeight: "300px",
    overflowY: "auto",
    [theme.breakpoints.down("md")]: {
      maxWidth: 250,
    },
  },
  hrmsGlobalSearchHeader: {
    display: "flex",
    margin: "5px 0px",
  },
  hrmsGlobalSearchHeaderText: {
    marginLeft: "5px",
  },
  hrmsGlobalSearchDivider: {
    margin: "10px 0px",
    borderColor: theme.palette.primary[200],
  },
}));
const GlobalSearchResult = ({
  open,
  anchorEl,
  handleClose,
  data = [],
  searchString,
}) => {
  const classes = useStyle();
  const highlightText = (text) => {
    if (typeof text === "undefined") {
      return "";
    }
    const regex = new RegExp(`(${searchString})`, "gi");
    const parts = text.split(regex);

    return parts.map((part, index) => {
      if (part.match(regex)) {
        return <mark key={index}>{part}</mark>;
      } else {
        return part;
      }
    });
  };
  return (
    <Popper
      anchorEl={anchorEl}
      open={open}
      transition
      disablePortal
      popperOptions={{
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, 9],
            },
          },
        ],
      }}
    >
      {({ TransitionProps }) => (
        <Transitions type="fade" in={open} {...TransitionProps}>
          <Paper className={classes.hrmsGlobalSearchResult}>
            <ClickAwayListener onClickAway={handleClose}>
              <MainCard elevation={0} border={false} content={false}>
                <CardContent sx={{ px: 2.5, pt: 3 }}>
                  <Grid>
                    {Object.keys(data).map((category) => (
                      <div key={category}>
                        {data[category].length > 0 && (
                          <>
                            {/* Header  */}
                            <div className={classes.hrmsGlobalSearchHeader}>
                              {icons[category]}
                              <Typography
                                variant="h5"
                                className={classes.hrmsGlobalSearchHeaderText}
                              >
                                {category}
                              </Typography>
                            </div>

                            {data[category].map((item) => (
                              <div key={item.id}>
                                {/* Project */}

                                {category === "Projects" && (
                                  <ProjectSearch
                                    highlightText={highlightText}
                                    item={item}
                                  />
                                )}

                                {/* Designation */}
                                {category === "Designations" && (
                                  <DesignationSearch
                                    highlightText={highlightText}
                                    item={item}
                                  />
                                )}

                                {/* Deaprtment */}
                                {category === "Departments" && (
                                  <DepartmentSearch
                                    highlightText={highlightText}
                                    item={item}
                                  />
                                )}

                                {/* Role */}
                                {category === "Roles" && (
                                  <RoleSearch
                                    highlightText={highlightText}
                                    item={item}
                                  />
                                )}

                                {/* Employee */}
                                {category === "Employee" && (
                                  <EmployeeSearchCard
                                    highlightText={highlightText}
                                    item={item}
                                  />
                                )}

                                {/* Company */}
                                {category === "Companies" && (
                                  <CompanySearch
                                    highlightText={highlightText}
                                    item={item}
                                  />
                                )}
                              </div>
                            ))}
                            <Divider
                              className={classes.hrmsGlobalSearchDivider}
                            />
                          </>
                        )}
                      </div>
                    ))}
                    {Object.keys(data).every(
                      (category) => data[category].length === 0
                    ) && <Typography>No search results found</Typography>}
                  </Grid>
                </CardContent>
              </MainCard>
            </ClickAwayListener>
          </Paper>
        </Transitions>
      )}
    </Popper>
  );
};

export default GlobalSearchResult;
